import { render, staticRenderFns } from "./TextParse.vue?vue&type=template&id=3816707e&"
import script from "./TextParse.vue?vue&type=script&lang=js&"
export * from "./TextParse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports